import React, { useEffect, useState } from "react";
import { MdModeEditOutline, MdCloudUpload } from "react-icons/md";
import { useParams } from "react-router-dom";
import { updateCourseSeoMetadataApi } from "Services/allApi";
import { getCourseSeoMetadataApi } from "Services/allApi";
import { useNavigate } from "react-router-dom";
import { getListTag } from "Services/allApi";
import { getTrainerDataApi } from "Services/allApi";
import axios from "axios";
import { toast } from "react-toastify";
import { ToastContainer } from "react-toastify";


const Edit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [data, setData] = useState({});
  const [seoData, setSeoData] = useState({});
  const [newImage, setNewImage] = useState(null);
  const [newBrochure, setNewBrochure] = useState(null);
  const [newOgImage, setNewOgImage] = useState(null);
  const [originalData, setOriginalData] = useState({});
  const [originalSeoData, setOriginalSeoData] = useState({});
  const [tagData, setTagData] = useState([]);
  const [trainersData, setTrainersData] = useState([]);
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [customMetaTags, setCustomMetaTags] = useState({});
  const [customMetaTagsText, setCustomMetaTagsText] = useState("");

  useEffect(() => {
    fetchCourseDetails();
  }, [id]);

  const fetchCourseDetails = async () => {
    const response = await getCourseSeoMetadataApi(id);
    if (response && !response.error) {
      setData(response.data);
      setSeoData(response.data.seo_meta_data || {});
      setOriginalData(response.data);
      setOriginalSeoData(response.data.seo_meta_data || {});
      setSelectedTrainers(response.data.trainers || {});
    } else {
      toast.error("Failed to fetch course details:", response?.message);
    }
  };

  useEffect(() => {
    const fetchTagList = async () => {
      const response = await getListTag();
      if (response && !response.error) {
        setTagData(response.data);
      } else {
        console.error("Failed to fetch tag details:", response?.message);
      }
    };
    fetchTagList();
  }, []);

  useEffect(() => {
    const fetchTrainerList = async () => {
      const response = await getTrainerDataApi();
      if (response && !response.error) {
        console.log(response.data);
        setTrainersData(response.data);
      } else {
        toast .error("Failed to fetch Trainer details:", response?.message);
      }
    };
    fetchTrainerList();
  }, []);
  useEffect(() => {
    const metaTagsText = Object.entries(seoData.custom_meta_tags || {})
      .map(([key, value]) => `${key}=${value}`)
      .join("\n");
    setCustomMetaTagsText(metaTagsText);
  }, [seoData.custom_meta_tags]);

  const handleModulesClick = (id) => {
    navigate(`/admin/modules-courses/${id}`, {
      state: { cardTitle: data.card_title },
    });
  };

  const handleProgramClick = (id) => {
    navigate(`/admin/program-courses/${id}`, {
      state: { cardTitle: data.card_title },
    });
  };

  const handleSupportClick = (id) => {
    navigate(`/admin/support-courses/${id}`, {
      state: { cardTitle: data.card_title },
    });
  };

  const handleSection1Click = (id) => {
    navigate(`/admin/section1-courses/${id}`, {
      state: { cardTitle: data.card_title },
    });
  };

  const handleSection2Click = (id) => {
    navigate(`/admin/section2-courses/${id}`, {
      state: { cardTitle: data.card_title },
    });
  };

  const handleChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleTrainerChange = (e) => {
    setData({ ...data, "trainers": JSON.stringify(selectedTrainers) });
  };

  const handleSeoChange = (e) => {
    setSeoData({ ...seoData, [e.target.name]: e.target.value });
  };

  const handleCustomMetaTagsChange = (e) => {
    const text = e.target.value;
    setCustomMetaTagsText(text);

    // Convert the textarea content back into an object
    const newMetaTags = text.split("\n").reduce((acc, line) => {
      const [key, value] = line.split("=");
      if (key && value) {
        acc[key.trim()] = value.trim();
      }
      return acc;
    }, {});

    // Update the custom_meta_tags state
    setCustomMetaTags(newMetaTags);
  };

  const handleSave = async (e) => {
    e.preventDefault();



    // Initialize the payload with changed values only
    const payload = {};
    // const seoMetaData = {};

    for (let key in data) {
      if (data[key] !== originalData[key]) {
        payload[key] = data[key];
      }
    }

    for (let key in seoData) {
      if (seoData[key] !== originalSeoData[key]) {
        payload[key] = seoData[key];
      }
    }

    // Add newOgImage to seoMetaData if it exists
    if (newOgImage) payload["og_image"] = newOgImage;
    if (newBrochure) payload["brochure"] = newBrochure;
    if (newImage) payload["image"] = newImage;
    // Only add seo_meta_data to the payload if it has changes
    // if (Object.keys(seoMetaData).length > 0) {
    //   payload['seo_meta_data'] = seoMetaData;
    // }

    // Debugging: Check the payload before sending
    console.log("Payload:", payload);

    const response = await updateCourseSeoMetadataApi(id, payload);

    if (response && !response.error) {
      toast.success("Data saved successfully!");
    } else {
      toast.error("Error saving data: " + (response.message || "Unknown error"));
    }
  };

  const handleUpdateTrainers = async () => {
    try {
      // Prepare the data to be sent in the POST request
      const postData = {
        trdata: selectedTrainers, // selectedTrainers is already an array of IDs
      };

      // Make the POST request using Axios
      const response = await axios.post(`https://website.luminartechnohub.com/api/course/trainer/update/${id}/`, postData);

      // Handle the response (e.g., show a success message)
      toast.info("Trainers updated successfully!");
  } catch (error) {
    toast.error("Error updating trainers: " + error.message);
  }
  };

  const handleCancel = () => {
    fetchCourseDetails()
  };

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewImage(file);
    }
  };

  const handleBrochureUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewBrochure(file);
    }
  };

  const handleOgImageUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setNewOgImage(file);
    }
  };

  const seoLabelMap = {
    page_url: "Page URL",
    title: "SEO Title",
    meta_description: "Meta Description",
    meta_keywords: "Meta Keywords",
    meta_robots: "Meta Robots",
    canonical_url: "Canonical URL",
    og_title: "OG Title",
    og_description: "OG Description",
    og_image: "OG Image",
    og_url: "OG URL",
    og_site_name: "OG Site Name",
    og_locale: "OG Locale",
    owner: "Owner",
    custom_meta_tags: "Custom Meta Tags",
  };

  const courseLabelMap = {
    main_title: "Course Title",
    raing: "Course Rating",
    main_short_description: "Short Description",
    main_description: "Full Description",
    card_title: "Card Title",
    card_description: "Card Description",
    card_bottom_content: "Card Bottom Content",
    admission_fee: "Admission Fee",
    emi_fee: "EMI Fee",
    full_amt_fee: "Full Amount Fee",
    duration: "Course Duration",
    session_duration: "Session Duration",
    class_schedule: "Class Schedule",
    class_mode: "Class Mode",
    enrolled_students_count: "Enrolled Students",
    languages_and_tools_count: "Languages & Tools",
    brochure: "Brochure",
    order: "Order",
    display_home_page: "Display on Home Page",
    total_star_value: "Total Star Value",
    first_star_value: "First Star Value",
    second_star_value: "Second Star Value",
    third_star_value: "Third Star Value",
    four_star_value: "Four Star Value",
    five_star_value: "Five Star Value",
    tag: "Tag",
    slug:"Slug",
    seo_meta_data: "SEO Meta Data",
    trainers: "Trainers",
    disply_home_page: "Display Home Page",
    main_short_desription: "Main Short Description",
    see_more_btn_content: "See More Button Content",
  };

  const descriptionFields = [
    "main_short_description",
    "main_description",
    "card_description",
    "card_bottom_content",
    "meta_description",
    "og_description",
    "meta_keywords",
  ];



  return (
    <div className="mx-auto w-full max-w-6xl rounded-lg bg-white p-8 shadow-lg  dark:!bg-navy-700 dark:text-white">
  <h2 className="mb-6 text-4xl font-semibold">
    {data.card_title || "Course Title"}
  </h2>

  <div className="mb-6 flex space-x-4">
    <button className="rounded-md bg-purple-500 px-4 py-2 text-white">
      Home
    </button>
    <button
      onClick={() => handleModulesClick(id)}
      className="rounded-md bg-gray-500 px-4 py-2 text-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
    >
      Modules
    </button>
    <button
      onClick={() => handleProgramClick(id)}
      className="rounded-md bg-gray-500 px-4 py-2 text-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
    >
      Program
    </button>
    <button
      onClick={() => handleSupportClick(id)}
      className="rounded-md bg-gray-500 px-4 py-2 text-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
    >
      Support
    </button>
    <button
      onClick={() => handleSection1Click(id)}
      className="rounded-md bg-gray-500 px-4 py-2 text-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
    >
      Section 1
    </button>
    <button
      onClick={() => handleSection2Click(id)}
      className="rounded-md bg-gray-500 px-4 py-2 text-white dark:bg-gray-700 dark:text-white dark:border-gray-600"
    >
      Section 2
    </button>
  </div>

  <h2 className="mb-6 text-3xl font-semibold">SEO Meta Data</h2>
  <div className="mb-8 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
    {Object.keys(seoData).length > 0 ? (
      Object.keys(seoData)
        .filter(
          (key) =>
            !["id", "identifier", "created_at", "updated_at"].includes(key)
        )
        .map((key) => (
          <div key={key} className="sm:col-span-1">
            <label
              htmlFor={key}
              className="block font-medium text-gray-900 dark:text-white mb-2"
            >
              {seoLabelMap[key] || key}
            </label>
            {key === "meta_robots" ? (
              <select
                name={key}
                value={seoData[key] || ""}
                onChange={handleSeoChange}
                className="mt-2 block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:ring-indigo-400 sm:text-sm"
              >
                <option value="index, follow">index, follow</option>
                <option value="noindex, nofollow">noindex, nofollow</option>
              </select>
            ) : descriptionFields.includes(key) ? (
              <textarea
                name={key}
                value={seoData[key] || ""}
                onChange={handleSeoChange}
                className="mt-2 block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:ring-indigo-400 sm:text-sm"
              />
            ) : key === "og_image" ? (
              <div className="mt-2">
                <label
                  htmlFor="og-image-upload"
                  className="inline-flex cursor-pointer items-center text-purple-800 dark:text-purple-400"
                >
                  <MdCloudUpload className="mr-2" />
                  Upload OG Image
                </label>
                <input
                  type="file"
                  id="og-image-upload"
                  accept="image/*"
                  onChange={handleOgImageUpload}
                  style={{ display: "none" }}
                />
                {newOgImage && (
                  <div className="mt-4">
                    <p>Preview OG Image:</p>
                    <img
                      src={URL.createObjectURL(newOgImage)}
                      alt="OG Preview"
                      className="h-64 w-64 rounded-lg object-cover"
                    />
                  </div>
                )}
                {seoData.og_image && !newOgImage && (
                  <div className="mt-4">
                    <p>Current OG Image:</p>
                    <img
                      src={seoData.og_image}
                      alt="Current OG"
                      className="h-64 w-64 rounded-lg object-cover"
                    />
                  </div>
                )}
              </div>
            ) : key === "custom_meta_tags" ? (
              <div className="sm:col-span-2">
                <div className="mt-2">
                  <textarea
                    name="customMetaTags"
                    id="customMetaTags"
                    value={customMetaTagsText}
                    onChange={handleCustomMetaTagsChange}
                    rows="6"
                    className="block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:ring-indigo-400 sm:text-sm"
                  />
                </div>
              </div>
            ) : (
              <input
                name={key}
                type="text"
                value={seoData[key] || ""}
                onChange={handleSeoChange}
                className="mt-2 block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:ring-indigo-400 sm:text-sm"
              />
            )}
          </div>
        ))
    ) : (
      <p className="text-purple-800 dark:text-purple-400">
        No SEO metadata available for this course.
      </p>
    )}
  </div>

  <h2 className="mb-6 text-3xl font-semibold">Course Details</h2>
  <div className="relative mb-6 flex justify-center">
    <img
      src={newImage ? URL.createObjectURL(newImage) : data.image}
      alt="Course Thumbnail"
      className="h-64 w-64 rounded-lg object-cover"
    />
    <label
      htmlFor="image-upload"
      className="right-25 absolute bottom-2 cursor-pointer rounded-full bg-white p-2 text-purple-800 dark:bg-gray-700 dark:text-purple-400"
    >
      <MdModeEditOutline />
    </label>
    <input
      type="file"
      id="image-upload"
      accept="image/*"
      onChange={handleImageUpload}
      style={{ display: "none" }}
    />
  </div>

  <form onSubmit={handleSave} className="h-full w-full">
    <div className="space-y-12">
      <div className="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-2">
        {Object.keys(data)
          .filter(
            (key) =>
              key !== "id" && key !== "image" && key !== "seo_meta_data"
          )
          .map((key) => (
            <div key={key} className="sm:col-span-1">
              <label
                htmlFor={key}
                className="block font-medium text-gray-900 dark:text-white"
              >
                {courseLabelMap[key] || key}
              </label>
              {key === "brochure" ? (
                <div className="mt-2">
                  <label
                    htmlFor="brochure-upload"
                    className="inline-flex cursor-pointer items-center text-purple-800 dark:text-purple-400"
                  >
                    <MdCloudUpload className="mr-2" />
                    Upload Brochure
                  </label>
                  <input
                    type="file"
                    id="brochure-upload"
                    accept=".pdf"
                    onChange={handleBrochureUpload}
                    style={{ display: "none" }}
                  />
                  {newBrochure && (
                    <div className="mt-4">
                      <p>Brochure Preview:</p>
                      <a
                        href={URL.createObjectURL(newBrochure)}
                        className="text-purple-800 dark:text-purple-400"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Brochure
                      </a>
                    </div>
                  )}
                  {data.brochure && !newBrochure && (
                    <div className="mt-4">
                      <p>Current Brochure:</p>
                      <a
                        href={data.brochure}
                        className="text-purple-800 dark:text-purple-400"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Brochure
                      </a>
                    </div>
                  )}
                </div>
              ) : key === "disply_home_page" ? (
                <div className="mt-2">
                  <select
                    id="display-home-page"
                    value={data[key] ? "true" : "false"}
                    onChange={(e) =>
                      handleChange({
                        target: {
                          name: key,
                          value: e.target.value === "true",
                        },
                      })
                    }
                    className="block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-purple-800 sm:text-sm"
                  >
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              ) : key === "tag" ? (
                <div className="mt-2">
                  {/* <label htmlFor="tag-dropdown">Current Selection:</label> */}
                  <select
                    id="tag-dropdown"
                    value={data[key] || ""} // Ensure the current selection is shown
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      handleChange({
                        target: {
                          name: key,
                          value: selectedId,
                        },
                      });
                    }}
                    className="block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 focus:outline-purple-800 sm:text-sm"
                  >
                    <option value="" disabled>
                      Choose a tag
                    </option>
                    {tagData.map((tag) => (
                      <option key={tag.id} value={tag.id}>
                        {tag.key}
                      </option>
                    ))}
                  </select>
                </div>
              ) : key === "trainers" ? (
                <div className="mt-2">
                  <label className="block text-gray-700 dark:text-white">Select Trainers</label>
                  <div className="max-h-64 overflow-y-auto rounded-md border bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 p-3">
                    {trainersData.map((trainer) => (
                      <div
                        key={trainer.id}
                        className="mb-2 flex items-center space-x-4 border-b pb-2"
                      >
                        <img
                          src={trainer.image}
                          alt={trainer.name}
                          className="h-12 w-12 rounded-full object-cover"
                        />
                        <div className="flex-grow">
                          <p className="font-semibold text-gray-900 dark:text-white">{trainer.name}</p>
                          <p className="text-sm text-gray-500 dark:text-gray-400">{trainer.domain}</p>
                          <p className="text-xs text-gray-400 dark:text-gray-500">{trainer.role}</p>
                        </div>
                        <input
                          type="checkbox"
                          value={trainer.id}
                          checked={selectedTrainers.includes(trainer.id)}
                          onChange={(e) => {
                            const selectedId = Number(e.target.value);
                            if (e.target.checked) {
                              setSelectedTrainers((prev) => [...prev, selectedId]);
                            } else {
                              setSelectedTrainers((prev) =>
                                prev.filter((id) => id !== selectedId)
                              );
                            }
                          }}
                          className="h-4 w-4 text-purple-800 focus:ring-purple-800"
                        />
                      </div>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={handleUpdateTrainers}
                    className="mt-4 w-100 rounded-md px-4 py-1 text-green-500 border border-green-500 hover:bg-green-700 transition"
                  >
                    Update Trainers
                  </button>
                </div>
              ) : (
                <input
                  name={key}
                  type="text"
                  value={data[key] || ""}
                  onChange={handleChange}
                  className="mt-2 block w-full rounded-md bg-white dark:bg-[#0b14374d] dark:text-white dark:border-gray-600 px-3 py-1.5 text-base outline outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:ring-indigo-400 sm:text-sm"
                />
              )}
            </div>
          ))}
      </div>
    </div>

    <div className="mt-6 flex justify-end space-x-4">
      <button
        type="button"
        onClick={handleCancel}
        className="text-black rounded-md bg-gray-300 dark:bg-gray-600 px-4 py-2"
      >
        Cancel
      </button>
      <button
        type="submit"
        className="rounded-md bg-purple-800 px-4 py-2 text-white"
      >
        Save
      </button>
    </div>
  </form>
  <ToastContainer position="top-center" autoClose={5000} hideProgressBar={false} newestOnTop closeButton={true} />
</div>
  );
};

export default Edit;
